// biome-ignore lint/style/noRestrictedImports: wrapper function
import originalClsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const clsx = (...inputs: ClassValue[]) => {
  return twMerge(originalClsx(...inputs));
};
